import { render } from "./QuickNavAnchorLinks.vue?vue&type=template&id=2c94dd30"
import script from "./QuickNavAnchorLinks.vue?vue&type=script&lang=js"
export * from "./QuickNavAnchorLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__